﻿
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export namespace BaseRepository {
    export function isSuccessfulStatus(status: number): boolean {
        return status >= 200 && status < 300;
    }

    export function isSuccessfulOrValidationStatus(status: number): boolean {
        return isSuccessfulStatus(status)
            || status === 400;
    }

    export function getRequestConfig(headers: Record<string, string> = getHeaders(), allowValidationResult = false): AxiosRequestConfig {
        return {
            headers,
            validateStatus: allowValidationResult
                ? isSuccessfulOrValidationStatus
                : isSuccessfulStatus
        };
    }

    export function getValidationRequestConfig(headers: Record<string, string> = getHeaders()): AxiosRequestConfig {
        return getRequestConfig(headers, true);
    }

    export function getHeaders(): Record<string, string> {
        const headers: Record<string, string> = {
            RequestVerificationToken: window.softools.requestVerificationToken
        };

        if (window.softools.signalRConnectionId) {
            headers['SignalRConnectionId'] = window.softools.signalRConnectionId
        }

        return headers;
    }

    export async function get<T>(url: string): Promise<T> {
        const response: AxiosResponse<T> = await axios.get(url, getRequestConfig());
        return response.data;
    }

    export async function post<T>(url: string, data: any, contentType: string = ''): Promise<T> {
        let headers = getHeaders();

        if (contentType) {
            headers['Content-Type'] = contentType;
        }

        const response: AxiosResponse<T> = await axios.post(url, data, getValidationRequestConfig(headers));
        return response.data;
    }

    export async function patch<T>(url: string, data: any): Promise<T> {
        const response: AxiosResponse<T> = await axios.patch(url, data, getValidationRequestConfig());
        return response.data;
    }

    export async function del<T>(url: string): Promise<T> {
        const response: AxiosResponse<T> = await axios.delete(url, getValidationRequestConfig());
        return response.data;
    }

}
